import { useState, useEffect, useCallback } from "react";
import {
  Card,
  DatePicker,
  Row,
  Col,
  Form,
  Input,
  Checkbox,
  Select,
  InputNumber,
  Table,
  Typography,
  Divider,
  Space,
  Button,
} from "antd";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import {
  SALES_CONTRACT_LIST,
  STYLE_WISE_COST_ADD,
  STYLE_WISE_COST_VIEW,
  STYLE_WISE_COST_EDIT,
  REST_SALES_CONTRACT,
} from "../../../../apiServices/API_ENDPOINTS";

import { WEEKENDS } from "../../../../apiServices/API_ENDPOINTS";
import { postData, getData, putData } from "../../../../apiServices/common";
import {
  commaSeparateNumber,
  isArrayAndHasValue,
} from "../../../../utils/functions";
import HandleNotification from "../../../../common/Notification";
import CustomDatePicker from "common/CustomDatePicker";

const WeekendForm = (props) => {
  // Props
  const { form, editMode, viewMode } = props;
  // const [code, setCode] = useState("");

  //   States
  const [checkedDays, setCheckedDays] = useState([]);

  console.log("checkedDays", checkedDays);

  // Router
  const navigate = useNavigate();
  const { id } = useParams();

  const getSelectedWeekendInfo = useCallback(
    async (id) => {
      const query = `${WEEKENDS}/${id}/show`;
      const response = await getData(query);

      if (response && response?.data?.code === 200) {
        const daysData = response?.data?.data?.days?.map((item) => item?.days);
        //console.log('daysData', daysData);
        // unique days
        const uniqueDays = [...new Set(daysData)];

        setCheckedDays(uniqueDays);

        form.setFieldsValue({
          days: response?.data?.data?.days,
          effective_date: moment(response?.data?.data?.effective_date),
          entry_date: moment(response?.data?.data?.entry_date).format(
            "YYYY-MM-DD",
          ),
        });
      } else {
        HandleNotification(
          "error",
          "bottomRight",
          "Error in fetching weekend Info",
          null,
        );
      }
    },
    [form],
  );

  // const handleNameChange = (e) => {
  //   const name = e.target.value;
  //   // Replace spaces and special characters with dashes
  //   const codeValue = name.replace(/[^a-zA-Z0-9]/g, "-");
  //   setCode(codeValue);
  //   form.setFieldsValue({ code: codeValue });
  // };

  useEffect(() => {
    // get selected cost info on edit mode
    if (id) {
      getSelectedWeekendInfo(id);
    }
  }, [editMode, id, getSelectedWeekendInfo]);

  const onFinishWeekend = async (values) => {
    // console.log("values", values);
    // console.log("checkedDays", checkedDays);

    const query = editMode ? `${WEEKENDS}/${id}` : `${WEEKENDS}`;
    const bodyData = {
      days: checkedDays,
      effective_date: moment(values?.effective_date).format("YYYY-MM-DD"),
    };

    const response = editMode
      ? await putData(query, bodyData)
      : await postData(query, bodyData);

    console.log("response", response);

    if (response && response?.code === 200) {
      HandleNotification(
        "success",
        "bottomRight",
        `Weekend ${editMode ? "updated" : "added"} successfully!`,
        null,
      );
      form.resetFields();
      navigate("/production-planning/weekends");
    } else {
      HandleNotification(
        "error",
        "bottomRight",
        `Error ${editMode ? "updating" : "adding"} weekend!`,
        null,
      );
    }
  };

  const onCheck = (checkedValue) => {
    if (checkedDays.includes(checkedValue)) {
      const checkedDaysCopy = isArrayAndHasValue(checkedDays)
        ? [...checkedDays]
        : [];
      const index = checkedDaysCopy.indexOf(checkedValue);
      if (index > -1) {
        checkedDaysCopy.splice(index, 1);
      }
      setCheckedDays(checkedDaysCopy);
    } else {
      const checkedDaysCopy = isArrayAndHasValue(checkedDays)
        ? [...checkedDays]
        : [];
      checkedDaysCopy.push(checkedValue);
      setCheckedDays(checkedDaysCopy);
    }
  };
  console.log("checkedDays", checkedDays);
  return (
    <div className="containt-body pt-3">
      <Form
        layout="vertical"
        form={form}
        name="control-hooks"
        onFinish={onFinishWeekend}
      >
        {/* <Checkbox.Group style={{ width: "100%" }} onChange={onCheck}> */}
        <Row>
          <label className="form-label ant-col ant-col-24">
            <span style={{ color: "red" }}>*</span> Day's
          </label>
          <Col span={6}>
            <Checkbox
              value="Sunday"
              checked={checkedDays?.includes("Sunday")}
              onChange={(e) => onCheck(e?.target?.value)}
            >
              Sunday
            </Checkbox>
          </Col>
          <Col span={6}>
            <Checkbox
              value="Monday"
              checked={checkedDays?.includes("Monday")}
              onChange={(e) => onCheck(e?.target?.value)}
            >
              Monday
            </Checkbox>
          </Col>
          <Col span={6}>
            <Checkbox
              value="Tuesday"
              checked={checkedDays?.includes("Tuesday")}
              onChange={(e) => onCheck(e?.target?.value)}
            >
              Tuesday
            </Checkbox>
          </Col>
          <Col span={6}>
            <Checkbox
              value="Wednesday"
              checked={checkedDays?.includes("Wednesday")}
              onChange={(e) => onCheck(e?.target?.value)}
            >
              Wednesday
            </Checkbox>
          </Col>
          <Col span={6}>
            <Checkbox
              value="Thursday"
              checked={checkedDays?.includes("Thursday")}
              onChange={(e) => onCheck(e?.target?.value)}
            >
              Thursday
            </Checkbox>
          </Col>
          <Col span={6}>
            <Checkbox
              value="Friday"
              checked={checkedDays?.includes("Friday")}
              onChange={(e) => onCheck(e?.target?.value)}
            >
              Friday
            </Checkbox>
          </Col>
          <Col span={6}>
            <Checkbox
              value="Saturday"
              checked={checkedDays?.includes("Saturday")}
              onChange={(e) => onCheck(e?.target?.value)}
            >
              Saturday
            </Checkbox>
          </Col>
        </Row>
        {/* </Checkbox.Group> */}

        <Row gutter={24}>
          <Col className="gutter-row" span={12}>
            <Form.Item
              label="Effective date"
              name="effective_date"
              rules={[
                {
                  required: true,
                  message: "Effective date is required",
                },
              ]}
            >
              <CustomDatePicker />
              {/* <DatePicker format="YYYY-MM-DD" style={{ width: "100%" }} /> */}
            </Form.Item>
          </Col>
          <Col className="gutter-row" span={12}>
            <Form.Item
              label="Entry date"
              name="entry_date"
              initialValue={moment().format("YYYY-MM-DD")}
            >
              <CustomDatePicker
                value={moment()}
                placeholder="Entry Date"
                disabled
                size="small"
              />
              {/* <Input placeholder="Entry Date" disabled size="small"   /> */}
            </Form.Item>
          </Col>
          <Col className="gutter-row" span={12}>
            <Form.Item
              label="Entry User"
              name="entry_user"
              initialValue={localStorage.getItem("name") || "User"}
            >
              <Input placeholder="Entry Date" disabled size="small" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default WeekendForm;
